"use strict";
exports.__esModule = true;
exports.ManifestError = void 0;
var ManifestError;
(function (ManifestError) {
    ManifestError["PROJECT_NOT_FOUND"] = "personalize.MANIFEST.PROJECT_NOT_FOUND";
})(ManifestError = exports.ManifestError || (exports.ManifestError = {}));
//# sourceMappingURL=edge-api.errors.js.map